import { IExportConfig } from "../pages/PimaUpload";

export interface PostData {
    email: any ;
    image: File | null;
    file: File | null;
  }

  export interface IUploadFormProps {
    handleEmailChange:  (params: any) => any;
    handleFileChange: (params: any) => any;
    handleSubmit: (params: any) => any;
    handleConfigChange: (params: any) => any;
    handleExportFormatChange: (params: any) => any
    exportConfig: IExportConfig,

    isSuccess:boolean;
    isLoading:boolean;
    progress:number;
    formValues:PostData
  }

  export interface IDropDown {
    row:  any;
    options:  any;
    handleSelectionChange: (params: any, rowNum: number) => any;
  }

  export interface ICheckedITem {
    label: string | null,
    productId: number | null,
    productName: string | null,
    vendorId: number | null,
    vendorName: string | null,
    description: string | null,
    group: string,
    isExchange: boolean
  }

  export interface IOverideItem {
    isChecked:  boolean;
    checkedItem:  ICheckedITem | null;
   
  }

  export interface IOverrideSearchOptions {
      label: string | null,
      productId: number | null,
      vendorId: number | null,

  }

  export const EXPORT_FORMAT_FIXED_COLUMN = 1;
  export const EXPORT_FORMAT_VARIABLE_COLUMN = 2;
  export const EXPORT_FORMAT_EXTENDED_VARIABLE_ROWS = 3;
  
  export const MAX_PRODUCT_COMPETITORS = 5;